import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@consigli/shadcn';
import { FC, ReactNode } from 'react';

interface ModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  title: ReactNode;
  description?: string;
  children?: ReactNode;
  footer?: ReactNode;
  trigger?: ReactNode;
  showCloseButton?: boolean;
  className?: string;
}

export const Modal: FC<ModalProps> = ({
  isOpen,
  onOpenChange,
  title,
  description,
  children,
  footer,
  trigger,
  showCloseButton = false,
  className,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      {trigger}
      <DialogContent showCloseButton={showCloseButton} className={className}>
        <DialogHeader>
          <DialogTitle className="text-lg font-semibold">{title}</DialogTitle>
          {description && (
            <DialogDescription className="text-sm text-gray-600">{description}</DialogDescription>
          )}
        </DialogHeader>

        {children && <div className="py-4">{children}</div>}

        {footer && <DialogFooter className="flex gap-2 sm:justify-end">{footer}</DialogFooter>}
      </DialogContent>
    </Dialog>
  );
};
